// Lote V-9 — Landing tras un checkout abandonado de kit LeyroSpot.
// Stripe redirixe aquí cando o usuario pecha o flow sen pagar. Non se
// rexistra HardwareOrder. Mostramos un retry-friendly CTA.

import { ShoppingBag, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ContentPage from '../components/ui/ContentPage';

export default function ShopCancelPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <ContentPage title={t('shopCancel.title')} category={t('shop.category')}>
      <section className="not-prose flex flex-col items-center text-center gap-4 py-8">
        <div className="w-16 h-16 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center">
          <XCircle size={36} />
        </div>
        <p className="text-base text-dark font-medium max-w-md">{t('shopCancel.body')}</p>
        <Link
          to="/marketplace/shop"
          className="mt-4 inline-flex items-center gap-2 bg-rauxa text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-rauxa/90"
        >
          <ShoppingBag size={16} /> {t('shopCancel.retry')}
        </Link>
      </section>
    </ContentPage>
  );
}
